import styled from 'styled-components';

const themes = {
  1: {
    colorBkgOn: 'var(--color-black)',
    colorBkgHoverOn: 'var(--color-grey-11_60)',
    colorBkgDisabledOn: 'var(--color-grey-10_10)',
    colorDotOn: 'var(--color-white)',
    colorDotDisabledOn: 'var(--color-grey-13_16)',
    colorBkgOff: 'var(--color-grey-12_30)',
    colorBkgHoverOff: 'var(--color-grey-11_60)',
    colorBkgDisabledOff: 'var(--color-grey-10_10)',
    colorDotOff: 'var(--color-white)',
    colorDotDisabledOff: 'var(--color-grey-13_16)',
  },
};

const sizes = {
  s: {
    switcherWidth: '26px',
    switcherHeight: '16px',
    dotWidth: '14px',
    dotHeight: '14px',
    gap: '6px',
    font: 'var(--font-regular-13)',
  },
  m: {
    switcherWidth: '33px',
    switcherHeight: '20px',
    dotWidth: '18px',
    dotHeight: '18px',
    gap: '8px',
    font: 'var(--font-regular-15)',
  },
  l: {
    switcherWidth: '40px',
    switcherHeight: '24px',
    dotWidth: '22px',
    dotHeight: '22px',
    gap: '12px',
    font: 'var(--font-regular-17)',
  },
};

export const Container = styled.label`
  --font: ${(p) => (sizes[p.size] || sizes['m']).font};
  --color-bkg-on: ${(p) => (themes[p.theme] || themes['1']).colorBkgOn};
  --color-bkg-off: ${(p) => (themes[p.theme] || themes['1']).colorBkgOff};
  --color-bkg-disabled-on: ${(p) => (themes[p.theme] || themes['1']).colorBkgDisabledOn};
  --color-bkg-disabled-off: ${(p) => (themes[p.theme] || themes['1']).colorBkgDisabledOff};
  --color-bkg-hover-on: ${(p) => (themes[p.theme] || themes['1']).colorBkgHoverOn};
  --color-bkg-hover-off: ${(p) => (themes[p.theme] || themes['1']).colorBkgHoverOff};
  --color-dot-on: ${(p) => (themes[p.theme] || themes['1']).colorDotOn};
  --color-dot-off: ${(p) => (themes[p.theme] || themes['1']).colorDotOff};
  --color-dot-disabled-on: ${(p) => (themes[p.theme] || themes['1']).colorDotDisabledOn};
  --color-dot-disabled-off: ${(p) => (themes[p.theme] || themes['1']).colorDotDisabledOff};
  --switcher-width: ${(p) => (sizes[p.size] || sizes['m']).switcherWidth};
  --switcher-height: ${(p) => (sizes[p.size] || sizes['m']).switcherHeight};
  --dot-width: ${(p) => (sizes[p.size] || sizes['m']).dotWidth};
  --dot-height: ${(p) => (sizes[p.size] || sizes['m']).dotHeight};
  --gap: ${(p) => (sizes[p.size] || sizes['m']).gap};
  --color-bkg: ${(p) => {
    if (p.checked) {
      return p.disabled ? 'var(--color-bkg-disabled-on)' : 'var(--color-bkg-on)';
    } else {
      return p.disabled ? 'var(--color-bkg-disabled-off)' : 'var(--color-bkg-off)';
    }
  }};
  --color-bkg-hover: ${(p) => {
    if (p.disabled) {
      return p.checked ? 'var(--color-bkg-disabled-on)' : 'var(--color-bkg-disabled-off)';
    }

    return p.checked ? 'var(--color-bkg-hover-on)' : 'var(--color-bkg-hover-off)';
  }};
  --dot-offset: ${(p) => (p.checked ? 'calc(100% - var(--dot-width) - 1px)' : '1px')};

  cursor: ${(p) => (p.disabled ? 'not-allowed' : 'pointer')};
  display: flex;
  align-items: center;
  gap: var(--gap);
`;

export const Switcher = styled.div`
  background-color: var(--color-bkg);
  border-radius: 18px;
  width: var(--switcher-width);
  height: var(--switcher-height);
  display: flex;
  align-items: center;
  transition: background-color linear 0.2s;

  &:hover {
    background: var(--color-bkg-hover);
  }
`;

export const Dot = styled.div`
  width: var(--dot-width);
  height: var(--dot-height);
  border-radius: 100px;
  background: ${(p) => (p.checked ? 'var(--color-dot-on)' : 'var(--color-dot-off)')};
  position: relative;
  left: var(--dot-offset);
  transition: left linear 0.1s;
`;

export const Label = styled.div`
  font: var(--font);
`;

export const InnerCheckbox = styled.input.attrs({ type: 'checkbox' })`
  visibility: hidden;
  display: none;
`;
